import { render, staticRenderFns } from "./HomeV1.vue?vue&type=template&id=97a14496&scoped=true&"
import script from "./HomeV1.vue?vue&type=script&lang=ts&"
export * from "./HomeV1.vue?vue&type=script&lang=ts&"
import style0 from "./HomeV1.vue?vue&type=style&index=0&id=97a14496&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a14496",
  null
  
)

export default component.exports